import styled from 'styled-components'

import { PairStatsPanelItem } from './pair-stats-panel-row-item'

import type { PairStatsPanelItemProps } from './pair-stats-panel-row-item'
import type { PairAudit } from '@root/entities/pair'

export type StatIntent = PairAudit.AuditStatus | 'Neutral'

type Props = PairStatsPanelItemProps

export const PairStatsPanelTopRowItem: React.FC<Props> = (props) => {
  return <Root {...props} />
}

const Root = styled(PairStatsPanelItem)`
  height: 60px;
  border-radius: 10px;
  background: var(--background-1);
`
